module.exports = __webpack_public_path__ + "img/r-148.8c74cf37.jpg";